<template>
  <div>
    <v-card>
      <v-form ref="form">
        <v-card-title>
          {{ this.titre || $t('recherche.export.criteres.newTitre') }}
        </v-card-title>
        <v-card-subtitle>
          <v-text-field
            v-model="titre"
            :label="$t('recherche.export.criteres.titre')"
            :rules="[obligatoireRule()]"
          />
        </v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="5" sm="12" v-if="typeObjet != 'contactExpire'">
              <v-radio-group
                v-model="criteresMemorises[typeObjet].scope"
                :label="$t('recherche.export.criteres.scopes.title')"
                row
                mandatory
              >
                <v-radio
                  v-for="scope in scopes"
                  :key="scope.code"
                  :label="scope.libelle"
                  :value="scope.code"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-radio-group
                v-model="criteresMemorises[typeObjet].format"
                :label="$t('recherche.export.criteres.formats.title')"
                row
                mandatory
              >
                <v-radio
                  v-for="format in formats"
                  :key="format.code"
                  :label="format.libelle"
                  :value="format.code"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <v-radio-group
                v-if="tailleVisible"
                v-model="criteresMemorises[typeObjet].taille"
                :label="$t('recherche.export.criteres.tailles.title')"
                row
                mandatory
              >
                <v-radio
                  v-for="taille in tailles"
                  :key="taille.code"
                  :label="taille.libelle"
                  :value="taille.code"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row align="stretch" align-content="center">
            <v-col cols="12" md="5">
              <v-card flat>
                <v-card-title>
                  {{
                    $t('recherche.export.criteres.criteresSelectionnes.title')
                  }}
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="headersCriteresSelectionnes"
                    :items="criteresMemorises[typeObjet].selectionnes"
                    item-key="code"
                    v-model="criteresCoches.selectionnes"
                    show-select
                    disable-pagination
                    disable-sort
                    hide-default-footer
                    dense
                    ref="criteresSelectionnes"
                  >
                    <template #item.ordonner="{item}">
                      <v-btn color="primary" icon @click="elementUp(item)">
                        <v-icon>mdi-arrow-up-thick</v-icon>
                      </v-btn>
                      <v-btn color="primary" icon @click="elementDown(item)">
                        <v-icon>mdi-arrow-down-thick</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              align="center"
              vertical-align="middle"
              cols="12"
              md="2"
              sm="12"
            >
              <v-btn
                :title="$t('recherche.export.criteres.button.add')"
                icon
                color="primary"
                @click="addElements()"
              >
                <v-icon>mdi-arrow-left-circle</v-icon>
              </v-btn>
              <v-btn
                :title="$t('recherche.export.criteres.button.remove')"
                icon
                color="primary"
                @click="removeElements()"
              >
                <v-icon>mdi-arrow-right-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="5" sm="12">
              <v-card flat>
                <v-card-title>
                  {{
                    $t('recherche.export.criteres.criteresDisponibles.title')
                  }}
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="headersCriteresDisponibles"
                    :items="criteresMemorises[typeObjet].disponibles"
                    item-key="code"
                    v-model="criteresCoches.disponibles"
                    show-select
                    disable-pagination
                    disable-sort
                    hide-default-footer
                    dense
                    ref="criteresDisponibles"
                  >
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn text color="primary" @click="exporter()">
          {{ $t('button.export') }}
        </v-btn>
        <v-btn text color="secondary" @click="save()">
          {{ $t('button.save') }}
        </v-btn>
        <v-btn v-if="id != null" text color="error" @click="remove()">
          {{ $t('button.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import ValidationRules from '@/plugins/mixins/ValidationRules';
import toasted from '@/utils/toasted';

export default {
  mixins: [ValidationRules],
  props: {
    typeObjet: {
      type: String,
    },
  },
  beforeCreate() {},
  created() {
    this.initListType();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},

  data() {
    const formats = [
      {
        code: 'xml',
        libelle: this.$t('recherche.export.criteres.formats.xml'),
        icon: 'mdi-xml',
      },
      {
        code: 'excel',
        libelle: this.$t('recherche.export.criteres.formats.excel'),
        icon: 'mdi-file-excel',
      },
      {
        code: 'pdf',
        libelle: this.$t('recherche.export.criteres.formats.pdf'),
        icon: 'mdi-file-pdf',
      },
    ];
    const tailles = [
      {
        code: 'A4',
        libelle: 'A4',
        icon: 'mdi-image-size-select-small',
      },
      {
        code: 'A3',
        libelle: 'A3',
        icon: 'mdi-image-size-select-large',
      },
    ];
    const scopes = [
      {
        code: 'selection',
        libelle: this.$t('recherche.export.criteres.scopes.selection'),
      },
      {
        code: 'all',
        libelle: this.$t('recherche.export.criteres.scopes.all'),
      },
    ];

    const headersCriteresDisponibles = [
      {
        text: this.$t('recherche.export.criteres.columns.headers.libelle'),
        value: 'libelle',
        sortable: false,
      },
    ];
    const headersCriteresSelectionnes = [
      {
        text: this.$t('recherche.export.criteres.columns.headers.libelle'),
        value: 'libelle',
        sortable: false,
      },
      {
        text: this.$t('recherche.export.criteres.columns.headers.ordonner'),
        value: 'ordonner',
        sortable: false,
        align: 'right',
      },
    ];
    const criteres = {
      contact: {
        type: 'contact',
        colonnes: [
          this.colonnePersonnePhysique('civilite'),
          this.colonnePersonnePhysique('nom'),
          this.colonnePersonnePhysique('prenoms'),
          this.colonnePersonnePhysique('personneMorale'),
          this.colonnePersonnePhysique('division'),
          this.colonnePersonnePhysique('titre'),
          this.colonnePersonnePhysique('typeContact'),
          this.colonnePersonnePhysique('moyenContactPrefere'),
          this.colonnePersonnePhysique('fonctionContact'),
          this.colonnePersonnePhysique('remplacant'),
          this.colonnePersonnePhysique('telephone'),
          this.colonnePersonnePhysique('fax'),
          this.colonnePersonnePhysique('mail'),
          this.colonnePersonnePhysique('adresse'),
          this.colonnePersonnePhysique('dateLimiteValidite'),
          this.colonnePersonnePhysique('instanceParticipant'),
          this.colonnePersonnePhysique('identifiant'),
          this.colonnePersonnePhysique('accesAgil'),
          this.colonnePersonnePhysique('acces'),
        ],
      },
      personneMorale: {
        type: 'personneMorale',
        colonnes: [
          this.colonnePersonneMorale('raisonSociale'),
          this.colonnePersonneMorale('nomUsuel'),
          this.colonnePersonneMorale('maisonsMeres'),
          this.colonnePersonneMorale('typePersonneMorale'),
          this.colonnePersonneMorale('domicilieeMDL'),
          this.colonnePersonneMorale('sirenOuSiret'),
          this.colonnePersonneMorale('cotiseA'),
          this.colonnePersonneMorale('filiales'),
          this.colonnePersonneMorale('adresse'),
          this.colonnePersonneMorale('telephone'),
          this.colonnePersonneMorale('fax'),
          this.colonnePersonneMorale('mail'),
          this.colonnePersonneMorale('siteInternet'),
        ],
      },
      instance: {
        type: 'instance',
        colonnes: [
          this.colonneInstance('nom'),
          this.colonneInstance('description'),
          this.colonneInstance('typeInstance'),
          this.colonneInstance('dateDebut'),
          this.colonneInstance('dateFin'),
          this.colonneInstance('referent'),
          this.colonneInstance('urlSharepoint'),
        ],
      },
      contactExpire: {
        type: 'contactExpire',
        colonnes: [
          this.colonneContactExpire('civilite'),
          this.colonneContactExpire('nom'),
          this.colonneContactExpire('prenoms'),
          this.colonneContactExpire('personneMorale'),
          this.colonneContactExpire('cotiseA'),
          this.colonneContactExpire('division'),
          this.colonneContactExpire('titre'),
          this.colonneContactExpire('typeContact'),
          this.colonneContactExpire('moyenContactPrefere'),
          this.colonneContactExpire('fonctionContact'),
          this.colonneContactExpire('remplacant'),
          this.colonneContactExpire('telephone'),
          this.colonneContactExpire('fax'),
          this.colonneContactExpire('mail'),
          this.colonneContactExpire('adresse'),
          this.colonneContactExpire('dateLimiteValidite'),
          this.colonneContactExpire('instanceParticipant'),
          this.colonneContactExpire('identifiant'),
          this.colonneContactExpire('accesAgil'),
          this.colonneContactExpire('acces'),
        ],
      },
    };

    return {
      // Les listes statiques
      scopes,
      formats,
      tailles,
      // Tous les critères existants
      criteres,

      // Entêtes pour les listes de critères
      headersCriteresDisponibles,
      headersCriteresSelectionnes,

      // selectionnes : Pour gérer la table de gauche
      // disponibles : Pour gérer la table de droite
      id: null,
      titre: null,
      criteresMemorises: {
        contact: {
          scope: null,
          format: null,
          taille: null,
          selectionnes: [],
          disponibles: [],
        },
        personneMorale: {
          scope: null,
          format: null,
          taille: null,
          selectionnes: [],
          disponibles: [],
        },
        instance: {
          scope: null,
          format: null,
          taille: null,
          selectionnes: [],
          disponibles: [],
        },
        contactExpire: {
          scope: null,
          format: null,
          taille: null,
          selectionnes: [],
          disponibles: [],
        },
      },
      // Pour gérer les sélections, bindé par le v-model des data-tables
      criteresCoches: {
        selectionnes: [],
        disponibles: [],
      },
      // Valeurs par défaut
      default: {
        scope: 'all',
        format: 'excel',
        taille: {
          contact: 'A3',
          personneMorale: 'A3',
          instance: 'A4',
        },
      },
    };
  },
  computed: {
    tailleVisible() {
      return 'pdf' === this.criteresMemorises[this.typeObjet].format;
    },
  },
  watch: {},
  methods: {
    // Calcul des critères de la liste
    colonnePersonnePhysique(code) {
      return this.colonne('contact', code);
    },
    colonnePersonneMorale(code) {
      return this.colonne('personneMorale', code);
    },
    colonneInstance(code) {
      return this.colonne('instance', code);
    },
    colonneContactExpire(code) {
      return this.colonne('contactExpire', code);
    },
    colonne(type, code) {
      return {
        code: code,
        libelle: this.$t(`recherche.export.criteres.${type}.${code}`),
        ordonner: null,
      };
    },

    // A l'initialisation (create), Pour retourver les critères précédemment sélectionnés
    initListType() {
      Object.entries(this.criteres).forEach(([type, critere]) => {
        this.criteresMemorises[type].disponibles = Array.from(critere.colonnes);
        this.criteresMemorises[type].scope = this.default.scope;
        this.criteresMemorises[type].format = this.default.format;
        this.criteresMemorises[type].taille = this.default.taille[type];
      });
    },

    // Gesttion de l'IHM

    // Pour sélectionner des colonnes, au clic sur le bouton add
    addElements() {
      if (
        Array.isArray(this.criteresCoches.disponibles) &&
        this.criteresCoches.disponibles.length > 0
      ) {
        // On met à jour les 2 tables sélectionnés et disponibles
        this.criteresMemorises[this.typeObjet].selectionnes.push(
          ...this.criteresCoches.disponibles,
        );
        // On trie les disponibles
        this.criteresMemorises[this.typeObjet].disponibles = Array.from(
          this.criteres[this.typeObjet].colonnes,
        ).filter(
          c => !this.criteresMemorises[this.typeObjet].selectionnes.includes(c),
        );
        // On vide la liste des cochés
        this.criteresCoches.disponibles = [];
      }
    },
    // Pour désélectionner des colonnes,  au clic sur le bouton remove
    removeElements() {
      if (
        Array.isArray(this.criteresCoches.selectionnes) &&
        this.criteresCoches.selectionnes.length > 0
      ) {
        // On met à jour les 2 tables sélectionnés et disponibles
        this.criteresMemorises[this.typeObjet].disponibles.push(
          ...this.criteresCoches.selectionnes,
        );
        // On trie les disponibles
        this.criteresMemorises[this.typeObjet].disponibles = Array.from(
          this.criteres[this.typeObjet].colonnes,
        ).filter(c =>
          this.criteresMemorises[this.typeObjet].disponibles.includes(c),
        );
        // Sans trier les sélectionnés
        this.criteresMemorises[
          this.typeObjet
        ].selectionnes = this.criteresMemorises[
          this.typeObjet
        ].selectionnes.filter(
          c => !this.criteresMemorises[this.typeObjet].disponibles.includes(c),
        );
        // On vide la liste des cochés
        this.criteresCoches.selectionnes = [];
      }
    },
    elementUp(elt) {
      if (elt) {
        var index = this.criteresMemorises[
          this.typeObjet
        ].selectionnes.findIndex(c => c.code === elt.code);
        if (index > 0) {
          this.criteresMemorises[this.typeObjet].selectionnes.splice(index, 1);
          this.criteresMemorises[this.typeObjet].selectionnes.splice(
            index - 1,
            0,
            elt,
          );
        }
      }
    },
    elementDown(elt) {
      if (elt) {
        var index = this.criteresMemorises[
          this.typeObjet
        ].selectionnes.findIndex(c => c.code === elt.code);
        if (
          index <
          this.criteresMemorises[this.typeObjet].selectionnes.length - 1
        ) {
          this.criteresMemorises[this.typeObjet].selectionnes.splice(index, 1);
          this.criteresMemorises[this.typeObjet].selectionnes.splice(
            index + 1,
            0,
            elt,
          );
        }
      }
    },

    // Gestion de la sortie de l'IHM
    /**
     * Appelée pour le save() et le exporter()
     */
    getCriteresExport() {
      var criteresExport = null;
      if (
        Array.isArray(this.criteresMemorises[this.typeObjet].selectionnes) &&
        this.criteresMemorises[this.typeObjet].selectionnes.length > 0
      ) {
        criteresExport = {
          scope: this.criteresMemorises[this.typeObjet].scope,
          format: this.criteresMemorises[this.typeObjet].format,
          taille:
            this.criteresMemorises[this.typeObjet].format === 'pdf'
              ? this.criteresMemorises[this.typeObjet].taille
              : this.default.taille[this.typeObjet],
          criteres: this.criteresMemorises[this.typeObjet].selectionnes.flatMap(
            c => c.code,
          ),
        };
      }
      return criteresExport;
    },
    /**
     * Procède à l'export
     */
    exporter() {
      var criteresExport = this.getCriteresExport();
      if (criteresExport != null) {
        this.$emit('exporter', criteresExport);
      } else {
        toasted.error(this.$t('recherche.export.error.emptySelection'));
      }
    },
    /**
     * Sauve le modèle d'export
     */
    save() {
      const ok = this.$refs.form.validate();
      if (ok) {
        var criteresExport = this.getCriteresExport();
        if (criteresExport != null) {
          this.$emit('save', {
            id: this.id,
            titre: this.titre,
            typeObjet: this.typeObjet,
            export: criteresExport,
          });
        } else {
          toasted.error(this.$t('recherche.export.error.emptySelection'));
        }
      }
    },
    /**
     * Supprime le modèle d'export
     */
    remove() {
      if (this.id) {
        this.$refs.form.resetValidation();
        this.$emit('remove', this.id);
      }
    },

    // Pour la communication depuis MesExports
    /**
     * Chargement d'un modèle d'export
     */
    select(mesExports) {
      this.titre = mesExports.titre;
      this.id = mesExports.id;
      this.criteresMemorises[this.typeObjet].scope =
        mesExports.export.scope || this.default.scope;
      this.criteresMemorises[this.typeObjet].format =
        mesExports.export.format || this.default.format;
      this.criteresMemorises[this.typeObjet].taille =
        mesExports.export.taille || this.default.taille[this.typeObjet];
      // Les critères sélectionnés sont vides avant de charger 'mesExports'
      this.criteresMemorises[this.typeObjet].selectionnes = [];
      // Les colonnes sont toutes disponibles avant de charger 'mesExports'
      this.criteresMemorises[this.typeObjet].disponibles = Array.from(
        this.criteres[this.typeObjet].colonnes,
      );
      // Les cases à cocher de sélection
      this.criteresCoches.disponibles = [];
      this.criteresCoches.selectionnes = [];
      // Les colonnes sélectionnées
      if (
        Array.isArray(mesExports.export.criteres) &&
        mesExports.export.criteres.length > 0
      ) {
        for (const cri of mesExports.export.criteres) {
          const critereSauvegarde = this.criteres[
            this.typeObjet
          ].colonnes.filter(c => cri === c.code)[0];
          if (
            this.criteresMemorises[this.typeObjet].disponibles.includes(
              critereSauvegarde,
            )
          ) {
            this.criteresMemorises[this.typeObjet].selectionnes.push(
              critereSauvegarde,
            );
          }
        }
      } else {
        this.criteresMemorises[this.typeObjet].selectionnes = [];
      }
      // Par différence, les colonnnes non sélectionnées
      this.criteresMemorises[this.typeObjet].disponibles = Array.from(
        this.criteres[this.typeObjet].colonnes,
      ).filter(
        c => !this.criteresMemorises[this.typeObjet].selectionnes.includes(c),
      );
      this.$refs.form.resetValidation();
    },
  },
};
</script>
